import {
  Flex,
  Image,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useState } from "react";

import { AvailibilityIcon } from "../../elements/AvailibilityIcon";
import { getCremNormYear } from "../../shared/utils/cremNormUtils";
import { TextPopover } from "../../components/TextPopover";
import { FixedNumberDisplay } from "../../elements/NumberDisplay";
import { useComparePageContext } from "../../shared/state/ComparePageContext";

export function CompareGeneralTable() {
  const { scenarios, situation } = useComparePageContext();
  const [open, setOpen] = useState(true);

  return (
    <Table
      className={open ? "open" : "closed"}
      sx={{ borderSpacing: "2rem 0" }}
      variant="compare"
    >
      <Thead>
        <Tr id="section-general">
          <Th onClick={() => setOpen(!open)}>
            <Flex>
              <Image
                h={4}
                mr={2}
                src="/svg/chevron.svg"
                transform={open ? "rotate(180deg)" : "rotate(0deg)"}
                transition="transform 0.2s"
                w={4}
              />
              Algemeen
            </Flex>
          </Th>
          <Th>Algemeen</Th>
          {scenarios.map((s) => (
            <Th key={s.id}>Algemeen</Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>
            <TextPopover trigger="De Standaard">
              De Standaard grenswaarde voor dit woningtype / Berekende netto
              warmtebehoefte (kWh/m<sup>2</sup>) van scenario.
            </TextPopover>
          </Td>
          <Td textAlign="center">
            <FixedNumberDisplay
              decimals={2}
              number={situation.calculation.deStandaardThresholdValue}
            />{" "}
            /{" "}
            <FixedNumberDisplay
              decimals={2}
              number={situation.calculation.heatDemand}
            />
          </Td>
          {scenarios?.map((scenario) => (
            <Td key={scenario.id} textAlign="center">
              <FixedNumberDisplay
                decimals={2}
                number={scenario.calculation.deStandaardThresholdValue}
              />{" "}
              /{" "}
              <FixedNumberDisplay
                decimals={2}
                number={scenario.calculation.heatDemand}
              />
            </Td>
          ))}
        </Tr>
        <Tr>
          <Td>
            <TextPopover trigger="Gasloos ready">
              De woning wordt klaargemaakt voor een gasloze toekomst.
            </TextPopover>
          </Td>
          <Td>
            <Flex justifyContent="center">
              <AvailibilityIcon
                available={
                  situation.calculation.heatDemand <
                  situation.calculation.deStandaardThresholdValue
                }
              />
            </Flex>
          </Td>
          {scenarios?.map((scenario) => (
            <Td key={scenario.id}>
              <Flex justifyContent="center">
                <AvailibilityIcon
                  available={
                    scenario.calculation.heatDemand <
                    scenario.calculation.deStandaardThresholdValue
                  }
                />
              </Flex>
            </Td>
          ))}
        </Tr>
        <Tr>
          <Td>
            <TextPopover size="md" trigger="CRREM norm referentiejaar">
              CRREM staat voor Carbon Risk Real Estate Monitor. Het is een
              initiatief dat gericht is op energiebesparingen in gebouwen om te
              voldoen aan de klimaatdoelstellingen van het Klimaatakkoord van
              Parijs. Deze norm is geadopteerd door grote vastgoedbeleggers. De
              normweergave omvat het ambitiejaar met daaronder de CO2-uitstoot
              per vierkante meter bruto vloeroppervlak (gbo)
            </TextPopover>
          </Td>
          <Td>
            <Flex justifyContent="center">
              <Text>
                {getCremNormYear(
                  situation.calculation.yearlyCO2EmissionPerUsableArea,
                )}
              </Text>
            </Flex>
          </Td>
          {scenarios.map((scenario) => (
            <Td key={scenario.id}>
              <Flex justifyContent="center">
                <Text>
                  {getCremNormYear(
                    scenario.calculation.yearlyCO2EmissionPerUsableArea,
                  )}
                </Text>
              </Flex>
            </Td>
          ))}
        </Tr>
        <Tr>
          <Td>
            <TextPopover size="md" trigger="TOjuli">
              TOjuli staat voor &quot;TemperatuurOverschrijding juli&quot; en is
              een belangrijke eis om oververhitting in woningen en gebouwen te
              voorkomen.
            </TextPopover>
          </Td>
          <Td textAlign="center">{situation.calculation.toJuly.toFixed(2)}</Td>
          {scenarios.map((scenario) => (
            <Td key={scenario.id} textAlign="center">
              {scenario.calculation.toJuly.toLocaleString(
                document.documentElement.lang,
                { minimumFractionDigits: 0, maximumFractionDigits: 2 },
              )}
            </Td>
          ))}
        </Tr>
        <Tr>
          <Td>EPV</Td>
          <Td textAlign="center">
            <Flex justifyContent="center">
              {situation.energyPerformanceFeeCategoryName ?? (
                <AvailibilityIcon />
              )}
            </Flex>
          </Td>
          {scenarios.map((scenario) => (
            <Td key={scenario.id}>
              <Flex justifyContent="center">
                {scenario.energyPerformanceFeeCategoryName ?? (
                  <AvailibilityIcon />
                )}
              </Flex>
            </Td>
          ))}
        </Tr>
      </Tbody>
    </Table>
  );
}
